export default function useSearchParams(url = window.location.href) {
  const newUrl = new URL(url)

  return {
    searchParams: newUrl.searchParams,
  }
}
